import { extendTheme, StyleFunctionProps } from "@chakra-ui/react";

const theme = extendTheme({
  breakpoints: {
    sm: "320px",
    "2sm": "380px",
    md: "768px",
    lg: "960px",
    xl: "1200px",
    "2xl": "1600px",
    "3xl": "1920px",
  },
  fonts: {
    heading: `'IBM Plex Sans', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Pacifico'`,
    subHeading: `'IBM Plex Sans', sRoboto, 'Helvetica Neue', Arial, sans-serif`,
    body: `'IBM Plex Sans', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Pacifico'`,
  },
  textStyles: {
    h2: {
      "font-family": "var(--chakra-fonts-subHeading)",
    },
  },
  colors: {
    brand: "#D93F0B",
    brandTest: "#b63d05",
  },

  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        fontFamily: `'IBM Plex Sans', Roboto, 'Helvetica Neue', Arial, sans-serif, sans-serif`,
      },
    }),
  },
});

export default theme;
